<fui-page>
    <fui-page-pane>
        <fui-page-header [title]="'\'' + (title ? title : '') + '\''" [hasToggle]="true">
            <fui-page-header-nav>
                <ng-content select="wbo-page-navs"></ng-content>
            </fui-page-header-nav>
            <ng-content select="wbo-search-form"></ng-content>
        </fui-page-header>
        <fui-page-body>
            <fui-page-main>
                <fui-page-subject>
                    <ng-content></ng-content>
                </fui-page-subject>
            </fui-page-main>
        </fui-page-body>
    </fui-page-pane>
</fui-page>
